import React, { useState } from 'react';
import {
  Box,
  Grid,
  Card,
  CardHeader,
  Avatar,
  Typography,
} from '@mui/material';

const TechApproval = ({ approvalList }) => {
  return (
    <>
      <Box sx={{ mt: 2, mb: 2, px: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          {approvalList &&
            approvalList.map((doc, index) => {
             let statusName = "대기중";
             let color = "text.secondary"
              if(doc.docuYn==='S'){
                statusName="대기중";
              }else if(doc.docuYn === 'Y'){
                 statusName="승인";
                 color="success.main"
              }else if(doc.docuYn === 'N'){
                statusName="비승인";
                color="warning.main"
              }

              return(
                <Grid item xs={4} key={index}>
                <Card>
                  <CardHeader
                    avatar={
                      <Avatar alt={doc.docuUsr} src={doc.docuUsrProfile} />
                    }
                    title={`결재자${doc.docuStep} : ${doc.docuUsrDptNm} / ${doc.docuUsrNm} ${doc.docuUsrGradeNm}`}
                    subheader={
                      <React.Fragment>
                        <Box sx={{display:'flex', justifyContent:'flex-start', alignItems:'center'}}>
                        <Typography
                          component="div"
                          variant="body2"
                          color={color}
                        >
                         {statusName}
                        </Typography>
                        <Typography
                          component="div"
                          variant="body2"
                        >
                         {doc.docuDt !== null ? (`(${doc.docuDt})`):''} 
                        </Typography>
                        </Box>
                        <Typography
                          component="div"
                          variant="body2"
                          color="text.primary"
                        >
                           {doc.docuTxt !== null ? (`참고:${doc.docuTxt}`):''} 
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </Card>
              </Grid>
              )
            })}
        </Grid>
      </Box>
    </>
  );
};

export default TechApproval;
